<template lang="pug">
  .dialog-container(id="PlayListSorter-dialog")
    h5.warning
      span {{ $t('You may sort your playlist here, with provided original files. You can use either supplied form, or editor of your preference. Please leave id\'s intact, they will be used to properly identify media that appear multiple times on playlist.') }}
    el-input(type='textarea' :rows='rows' placeholder='Please input' v-model='playitemsFiles')
    .buttons.float-right
      el-button(id="PlayListSorter-sortAlphabetically", type='success', size="mini", :disabled='saving', @click='sortAlpha()')
        font-awesome-icon(icon="sort-alpha-down")
        span &nbsp; {{$t('Reorder form alphabetically')}}
      el-button(id="PlayListSorter-saveOrder", type='success', size="mini", :disabled='saving', @click='submitOrder()')
        font-awesome-icon(icon="save")
        span &nbsp; {{ saving ? $t('saving...') : $t('Save order')}}
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import MediumIcon from './../Common/MediumIcon'

export default {
  mixins: [textUtils, mediaUtils],
  props: ['mediumId'],
  components: {
    MediumIcon
  },
  async created () {
    this.loadData()
  },
  data () {
    return {
      errors: {
      },
      playlist: undefined,
      playitemsFiles: '',
      saving: false
    }
  },
  methods: {
    async loadData () {
      this.playlist = (await Vue.axios
        .post('medium/getPlaylistContentSimple', {
          PlayList: this.mediumId
        })).data
      this.playitemsFiles = this.__preparePlayitemsFiles()
    },
    __preparePlayitemsFiles () {
      return this.playlist.PlayListItems.map((pli) => {
        if (['Video', 'Audio', 'Image'].includes(pli.Medium.type)) {
          return pli.File.originalfilename + `(id=${pli.id})`
        } else {
          return pli.Medium.name + `(id=${pli.id})`
        }
      }).join('\n')
    },
    sortAlpha () {
      this.playitemsFiles = this.playitemsFiles.split('\n').sort((a, b) => a.localeCompare(b)).join('\n')
    },
    async submitOrder () {
      this.saving = true
      const orderedItems = []
      for (const playitem of this.playitemsFiles.split('\n')) {
        const id = parseInt(playitem.slice(0, -1).split('(id=')[1])
        orderedItems.push(id)
      }
      await Vue.axios
        .post('medium/setPlaylistOrder', {
          playListId: this.mediumId,
          orderedItems
        })
      this.saving = false
    }
  },
  computed: {
    rows () {
      return this.playitemsFiles.split('\n').length
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.header {
  font-size: $--font-size-big;
  font-weight: bold;
}
.buttons {
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/PlayListSorter.vue